const {
  default: Dashboard,
} = require("../components/admin/dashboard/Dashboard");
const { AllPermmission } = require("../features/admin/common/Slice");

exports.APIS = {
  Auth: "/common/auth/admin-login",

  Dashboard: "/admin/dashboard",

  Masters: {
    Country: "/admin/masters/country",
    State: "/admin/masters/state",
    City: "/admin/masters/city",
    Pincode: "/admin/masters/pincode",
    Orientation: "/admin/masters/orientation",
    PrintingLocations: "/admin/masters/printing-locations",
    Materials: "/admin/masters/materials",
    Laminations: "/admin/masters/laminations",
    Shapes: "/admin/masters/shapes",
    Partners: "/admin/masters/partners",
    WhyChooseUs: "/admin/masters/whychooseus",
    Industry: "/admin/masters/industry",
    Department: "/admin/masters/department",
    CompanySize: "/admin/masters/companysize",
    Faq: "/admin/masters/faqs",
    SubFaq: "/admin/masters/subfaq",
    Qty: "/admin/masters/qty",
    Envelopes: "/admin/masters/envelopes",
    SocialMedia: "/admin/masters/socialmedia",
    Coupons: "/admin/masters/coupons",
    Privacy_and_Policy: "/admin/masters/privacyandpolicy",
    Return_Policy: "/admin/masters/returnpolicy",
    Terms_and_Conditions: "/admin/masters/termsandconditions",
    Career: "/admin/masters/careers",
    Blog_Category: "/admin/masters/blog_categories",
    Blog: "/admin/masters/blogs",
    Size: "/admin/masters/sizes",
    Help: "/admin/masters/help",
  },

  // common
  Commons: {
    AllCountry: "/common/masters/all-country",
    AllState: "/common/masters/all-state",
    AllCity: "/common/masters/all-city",
    AllPincode: "/common/masters/all-pincode",
    AllCategory: "/common/masters/all-category",
    AllSubCategory: "/common/masters/all-subcategory",
    AllChildCategory: "/common/masters/all-childcategory",
    AllPartners: "/common/masters/all-partners",
    AllWhyChooseUs: "/common/masters/all-whychooseus",
    AllIndustry: "/common/masters/all-industry",
    AllDepartment: "/common/masters/all-department",
    AllCompanySize: "/common/masters/all-companysize",
    AllNeeds: "/common/masters/all-needs",
    AllFaq: "/common/masters/all-faqs",
    AllSubFaq: "/common/masters/all-subfaq",

    AllMeterial: "/common/masters/all-material",
    AllLamination: "/common/masters/all-lamination",
    AllEnvelope: "/common/masters/all-envelope",
    AllPrintLocation: "/common/masters/all-print-location",
    AllQuantity: "/common/masters/all-quantity",
    AllOrientation: "/common/masters/all-Orientation",
    AllShapes: "/common/masters/all-shapes",

    AllSocialMedia: "/common/masters/all-socialmedia",
    AllBlog: "/common/masters/all-blogs",
    AllBlog_Category: "/common/masters/all-blogcategory",
    AllSize: "/common/masters/all-size",
    AllDownloadType: "/common/masters/all-download-type",
    AllOrderStatus: "/common/masters/all-order-status",
    AllPermmission: "/common/masters/all-permission",

    AllRoles: "/common/masters/all-roles",

    AllTeam: "/common/masters/all-team",
    AllProduct: "/common/masters/all-product",
  },

  //product Manage
  ProductManage: {
    Category: "/admin/productmanage/category",
    SubCategory: "/admin/productmanage/subcategory",
    ChildCategory: "/admin/productmanage/childcategory",
    Needs: "/admin/productmanage/needs",
    Product: "/admin/productmanage/product",
    OfferProduct: "/admin/productmanage/offered-product",
  },

  OrderManage: {
    Order: "/admin/order-management/order",
    OrderStatus: "/admin/order-management/order-status",
    PaymentProof: "/admin/order-management/accountant-payment-proof",
    PrintingCount: "/admin/order-management/printing-count",
    QCComment: "/admin/order-management/qc-comment",
    AssignDesigner: "/admin/order-management/assign-designer",

     DesignerNote: "/admin/order-management/designer-notes",
  },

  AboutUs: {
    Welcome: "/admin/aboutus/welcomes",
    What_We_Are: "/admin/aboutus/what_we_ares",
    What_Media_Do: "/admin/aboutus/what_media_dos",
  },

  Customers: {
    Contact_Us: "/admin/contact-us",
    User: "/admin/customer",
  },

  ReviewRating: {
    ReviewRating: "/admin/review-rating",
  
  },

  UserManagement: {
    Roles: "/admin/employee-management/role",
    Employee: "/admin/employee-management/users",
  },
};
